/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedChannelRequest
 */
export interface APIPatchedChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedChannelRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedChannelRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the APIPatchedChannelRequest interface.
 */
export function instanceOfAPIPatchedChannelRequest(value: object): value is APIPatchedChannelRequest {
    return true;
}

export function APIPatchedChannelRequestFromJSON(json: any): APIPatchedChannelRequest {
    return APIPatchedChannelRequestFromJSONTyped(json, false);
}

export function APIPatchedChannelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedChannelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function APIPatchedChannelRequestToJSON(value?: APIPatchedChannelRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

